<template>
  <div v-if="loading" style="height: 6.25rem; overflow: hidden;">
    <radar-spinner
      :animation-duration="2000"
      :size="100"
      color="var(--color-secondary)"
    />
  </div>
</template>

<script>
// To use minified css and js files instead of .vue single file components:
import "epic-spinners/dist/lib/epic-spinners.min.css";
import { RadarSpinner } from "../../node_modules/epic-spinners/dist/lib/epic-spinners.min.js";

// import { AtomSpinner } from "epic-spinners";
export default {
  name: "Loader",
  components: {
    RadarSpinner
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  }
};
</script>
